import React, { createContext, useReducer } from 'react';
import reducer, { initialState } from './reducers/shifts.reducer';

const ShiftStateContext = createContext(null);
const ShiftDispatchContext = createContext(null);

function ShiftProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);

  return (
    <ShiftStateContext.Provider value={state}>
      <ShiftDispatchContext.Provider value={dispatch}>{children}</ShiftDispatchContext.Provider>
    </ShiftStateContext.Provider>
  );
}

export { ShiftProvider, ShiftStateContext, ShiftDispatchContext };
